module.exports = __webpack_public_path__ + "static/media/paint-brush.1bbe3c7d.png";